export default __webpack_public_path__ + "static/media/593.322fc90a.png";